"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUTTON_STYLE = void 0;
exports.RenderWlfFooter = RenderWlfFooter;
exports.RenderFooter = RenderFooter;
exports.RenderAddress = RenderAddress;
exports.GetSourceEmail = GetSourceEmail;
var sprintf_js_1 = require("sprintf-js");
var CA_WLF = "cleveralpha-asset-management";
var CA_SUB_ADVISOR_FOOTER = "Sub-advisor:  CleverAlpha Asset Management, LLC   is an investment adviser registered "
    + "with the Securities and Exchange Commission (SEC). Any reference to the advisory "
    + "services refers to CleverAlpha Asset Management, LLC. Registration does not imply a "
    + "certain level or training nor does it imply an endorsement by the SEC. Past performance "
    + "is not a guarantee of future results, nor is it necessarily indicative of any future "
    + "performance. Please keep in mind that investing involves risks. 425 15th Street Suite 3321 "
    + "Manhattan Beach, CA 90266";
function COPYRIGHT_FOOTER_WLF(year, name) {
    return (0, sprintf_js_1.sprintf)("© %04d %s", year, name);
}
function RenderWlfFooter(wlf, year) {
    var wlf_footer = wlf.info.footer
        ? wlf.info.footer.map(function (foot) { return "<p>".concat(foot, "</p>"); }).join("")
        : "";
    var copyright = COPYRIGHT_FOOTER_WLF(year, wlf.name);
    // We only do the CA Subadvisor clause if the WLF is NOT a B/D
    var do_subadvisor = !wlf.broker_dealer;
    var sub_advisor_text = do_subadvisor
        ? "<p>".concat(CA_SUB_ADVISOR_FOOTER, "</p>")
        : "";
    return "\n  <footer>\n    ".concat(wlf_footer, "\n    ").concat(sub_advisor_text, "\n    <p>").concat(copyright, "</p>\n  </footer>\n  ");
}
var FOOTER_0 = "CleverAlpha is an investment adviser registered with the Securities and "
    + "Exchange Commission (SEC). Any reference to the advisory services refers "
    + "to CleverAlpha Asset Management, LLC. Registration does not imply a "
    + "certain level or training nor does it imply an endorsement by the SEC. "
    + "Past performance is not a guarantee of future results, nor is it "
    + "necessarily indicative of any future performance. Please keep in mind "
    + "that investing involves risks.";
function COPYRIGHT_FOOTER(year) {
    return (0, sprintf_js_1.sprintf)("Copyright © %04d CleverAlpha Asset Management, LLC | All Rights Reserved", year);
}
// Creates a square box around text, making it look like a button
exports.BUTTON_STYLE = "-webkit-appearance: button; -moz-appearance: button;" +
    "appearance: button; text-decoration: none; color: initial;" +
    "background-color: #DDD; padding: 0.5rem";
function RenderCAFooter(year) {
    var copyright = COPYRIGHT_FOOTER(year);
    return "\n  <footer>\n    <p>".concat(FOOTER_0, "</p>\n    <p>").concat(copyright, "</p>\n  </footer>\n  ");
}
function RenderFooter(wlf) {
    var year = new Date().getFullYear();
    if (wlf.id === CA_WLF) {
        return RenderCAFooter(year);
    }
    return RenderWlfFooter(wlf, year);
}
function RenderAddress(wlf, do_name) {
    if (do_name === void 0) { do_name = false; }
    var all = wlf.info.address.concat(wlf.info.phone);
    if (do_name) {
        all.unshift(wlf.name);
    }
    return '<div>'
        + all.join("<br>")
        + "</div>";
}
var DEFAULT_SOURCE_EMAIL = "support@cleveralpha.com";
function GetSourceEmail(wlf) {
    if (wlf.email && wlf.email.source_email) {
        return wlf.email.source_email;
    }
    return DEFAULT_SOURCE_EMAIL;
}
//# sourceMappingURL=util.js.map